import React, { useEffect, useState } from "react";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

export default function Loading({ open = false }) {
  const classes = useStyles();
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    window.startLoading = () => {
      setOpen(true);
    };
    window.stopLoading = () => {
      setOpen(false);
    };
  }, []);

  return (
    <div>
      <Backdrop
        className={classes.backdrop}
        open={open || isOpen}
        onClose={() => {
          setOpen(true);
        }}
        style={{ zIndex: "99999999999" }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
